<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="header">
        <span>灰度用户</span>
        <span class="header-tip">勾选需要灰度的用户，点击保存生效</span>
      </div>

      <!-- 企业列表：企业只有展开箭头，用户前面是复选框 -->
      <el-tree
          :data="treeData"
          node-key="id"
          :props="{label: 'name', children: 'users'}"
          :expand-on-click-node="false"
          v-loading="loading"
          class="gray-tree">
        <span slot-scope="{data}" class="tree-node">
          <!-- 企业节点：仅名称 -->
          <template v-if="data.isQiye">
            <span>{{ data.name }}</span>
            <span class="user-count">{{ data.users.length }}</span>
          </template>
          <!-- 用户节点：复选框勾选 -->
          <el-checkbox v-else
                       :value="checkedIds.includes(data.id)"
                       @change="val => handleUserCheck(data.id, val)"
                       class="user-checkbox">
            {{ data.name }}
          </el-checkbox>
        </span>
      </el-tree>

      <!-- 已勾选的用户：点 × 取消勾选 -->
      <div v-if="checkedIds.length > 0" class="checked-users">
        <span class="checked-label">已勾选：</span>
        <el-tag v-for="id in checkedIds"
                :key="id"
                closable
                size="small"
                class="checked-tag"
                @close="handleUserCheck(id, false)">
          {{ userNameOf(id) }}
        </el-tag>
      </div>

      <!-- 保存 -->
      <div class="footer">
        <span class="checked-info">已选 {{ checkedIds.length }} 个用户</span>
        <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'GrayUser',
  data() {
    return {
      treeData: [],
      checkedIds: [],
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadTree()
    this.loadGrayUsers()
  },
  methods: {
    loadTree() {
      this.loading = true
      this.$axios.post('/auth/user/tree').then(res => {
        this.treeData = res.tree.map(q => ({
          id: q.qiyeId,
          name: q.qiyeName,
          isQiye: true,
          users: q.users.map(u => ({id: u._id, name: u.userName})),
        }))
      }).finally(() => {
        this.loading = false
      })
    },
    loadGrayUsers() {
      this.$axios.post('/version/gray/user/list').then(res => {
        this.checkedIds = res.userList.map(u => u._id)
      })
    },
    userNameOf(id) {
      for (const qiye of this.treeData) {
        const user = qiye.users.find(u => u.id === id)
        if (user) return user.name
      }
      return id
    },
    handleUserCheck(id, checked) {
      if (checked) {
        this.checkedIds.push(id)
      } else {
        this.checkedIds = this.checkedIds.filter(i => i !== id)
      }
    },
    handleSave() {
      this.saving = true
      this.$axios.post('/version/gray/user/save', {ids: this.checkedIds}).then(() => {
        this.$message.success(`已保存 ${this.checkedIds.length} 个灰度用户`)
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>

<style scoped>
.header-tip {
  margin-left: 15px;
  color: #909399;
  font-size: 12px;
}

.gray-tree {
  max-height: calc(100vh - 260px);
  overflow: auto;
}

.tree-node {
  display: inline-flex;
  align-items: center;
}

.user-count {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}

.user-checkbox {
  font-weight: normal;
}

.checked-users {
  margin-top: 15px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.checked-label {
  color: #606266;
  font-size: 13px;
  margin-right: 5px;
}

.checked-tag {
  margin: 3px 5px 3px 0;
}

.footer {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.checked-info {
  margin-right: 15px;
  color: #606266;
  font-size: 13px;
}
</style>
